import { gql } from '@apollo/client';

import { ProfessorActivity } from '../../types';
import { professorActivityFragment } from '../fragments';

export interface GetActivitiesQueryVariables {
  courseId: string;
}

export interface GetActivitiesQueryResult {
  activities: ProfessorActivity[];
}

export const getActivitiesQuery = gql`
  query GetActivitiesQuery($courseId: String!) {
    activities(courseId: $courseId) @rest(type: "Activity", path: "courses/{args.courseId}/activities") {
      ...ProfessorActivity
    }
  }
  ${professorActivityFragment}
`;
